<app-alert></app-alert>
<router-outlet></router-outlet>

<ng-template #staticBackdropModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title text-dark" id="modalLabel">
      <i class="mdi mdi-alarm"></i> {{ "end_session.title" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <p class="m-0">{{ "end_session.message" | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="logOut()">
      {{ "end_session.buttons.cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "end_session.buttons.accept" | translate }}
    </button>
  </div>
</ng-template>
